'use client';
import { Simple as Tooltip } from '@/ui/Tooltip';
import Button from '@/ui/Button';
import { RocketIcon } from '@radix-ui/react-icons';
import { IRepository, IResourceVersion } from '@/types';
import useOxenSession from '@/hooks/useOxenSession';

interface NewEvaluationLinkProps {
  repository: IRepository;
  resource: IResourceVersion;
}

const NoAccessTooltipContent = () => (
  <>
    You do not have access to create evaluations in this repository.
    <br />
    To gain access, contact the repository owner to request edit or admin access.
  </>
);

const NewEvaluationLink: React.FC<NewEvaluationLinkProps> = ({ repository, resource }) => {
  const { config, authorization } = useOxenSession();
  const evaluationsEnabled = !!config?.evaluations_enabled;
  const linkUrl = `/${repository.namespace}/${repository.name}/evaluations/new?path=${resource.path}&version=${resource.version}`;

  const disabled = !authorization.forRepository(repository).canAccessEvaluations();

  return evaluationsEnabled ? (
    <Tooltip content={<NoAccessTooltipContent />} disabled={!disabled}>
      <Button.Magic disabled={disabled} outline small style={{ padding: 10 }} href={linkUrl} title="Evaluate this file">
        <RocketIcon />
      </Button.Magic>
    </Tooltip>
  ) : null;
};

export default NewEvaluationLink;
